import { IDirective } from 'angular';
import { GmcDatePickerController } from './gmc-date-picker.component';

export function gmcDatePickerInputDirective(): IDirective {
  return {
    restrict: 'A',
    require: '^gmcDatePicker',
    link: function postLink( scope, element, attrs, datePicker: GmcDatePickerController ) {
      datePicker.inputElement = element;
    }
  };
}

gmcDatePickerInputDirective.$inject = [];



// WEBPACK FOOTER //
// ./app/shared/components/gmc-date-picker/gmc-date-picker-input.directive.ts